var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import * as React from 'react';
import { createPortal } from 'react-dom';
import { canUseDOM } from '@progress/kendo-react-common';
/**
 * @hidden
 */
var DropClue = /** @class */function (_super) {
  __extends(DropClue, _super);
  function DropClue(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      height: 0,
      visible: false,
      left: 0,
      top: 0
    };
    _this.hiddenElementRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  DropClue.prototype.render = function () {
    var hiddenElement = this.hiddenElementRef.current;
    var dropClue = this.state.visible && canUseDOM && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
      className: "k-grouping-dropclue",
      style: {
        zIndex: 10000,
        display: 'block',
        top: this.state.top + 'px',
        left: this.state.left + 'px',
        height: this.state.height + 'px'
      }
    }), hiddenElement && hiddenElement.ownerDocument ? hiddenElement.ownerDocument.body : document.body);
    return /*#__PURE__*/React.createElement(React.Fragment, null, dropClue, /*#__PURE__*/React.createElement("div", {
      ref: this.hiddenElementRef,
      style: {
        display: 'none'
      }
    }));
  };
  return DropClue;
}(React.PureComponent);
export { DropClue };